<template>
  <div :class="['container']" v-if="category === 404">
    <h2 key="404h2" class="py-xl">
      Sorry... don't know nothing about this page.
    </h2>
    <h5 key="404h5">Seriously, no clue what your talking about!</h5>
  </div>
  <div
    v-else
    key="research"
    :class="[
      'research',
      mobileFiltersOpen ? 'filters-open' : '',
      !pageReady ? 'still-loading' : ''
    ]"
  >
    <preloader key="page-preloader" v-if="!pageReady" class="" />
    <template v-else>
      <slider
        ref="hero"
        v-if="hero"
        :size="elementSizes[0]"
        :resize-trig="resizeTrig"
        v-bind="hero"
        :class="['page-component', `el-size--${elementSizes[0]}`]"
      >
      </slider>

      <div
        ref="grid"
        class="research--inner page-component grid-flex-wrap px-2xl pt-2xl"
        :class="[`el-size--${elementSizes[0]}`]"
      >
        <i
          v-if="dimensions.width < 600"
          @click="mobileFiltersOpen = !mobileFiltersOpen"
          :class="[
            'toggle',
            'unflex',
            'fas',
            !mobileFiltersOpen ? 'fa-sliders-h' : 'fa-chevron-left'
          ]"
        ></i>
        <filter-panel
          v-if="pageReady"
          :class="[dimensions.width < 600 ? 'filter-panel__mobile' : '']"
          @mobile-filters-open="mobileFiltersChanged"
          @filters-changed="filtersChangedHandler"
          @search-by-string="searchByString"
          :trigger-query="triggerQueryChange"
          :ui-filters="filtersHash"
          :input-search="searchString"
          :mobile-open="mobileFiltersOpen"
        ></filter-panel>
        <div
          class="research--grid page-component flex-1 pb-3xl px-2xl"
          :class="[`el-size--${elementSizes[2]}`]"
          v-if="!mobileFiltersOpen"
        >
          <div class="page-header pb-2xl">
            <h3 class="font-rg" v-if="pageTitle" v-text="pageTitle"></h3>
            <div
              class="font-rg"
              v-if="pageSubTitle"
              v-html="localize('all_materials_english')"
            ></div>
          </div>
          <preloader v-if="!gridReady" key="loading"></preloader>
          <paginate
            ref="paginator"
            name="filteredItems"
            :list="filteredItems"
            :per="itemsPerPage"
            tag="div"
            class="paginate-langs"
            v-else
          >
            <keep-alive>
              <grid-items
                grid-type="research"
                :paginateditems="paginated('filteredItems')"
              ></grid-items>
            </keep-alive>
          </paginate>

          <transition name="slide-up" appear>
            <div class="pager align-left pt-l" v-if="hasPages">
              <paginate-links
                id="pager"
                ref="pager"
                for="filteredItems"
                :limit="4"
                :show-step-links="true"
                @change="onLangsPageChange"
                :step-links="{ next: localize('Next'), prev: localize('Prev') }"
              ></paginate-links>
            </div>
          </transition>
        </div>
      </div>
    </template>
    <keep-alive>
      <router-view v-if="currentItem" :currentItem="currentItem"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { storage } from "@/utils";

import FilterPanel from "@/components/FilterPanel.vue";
import GridItems from "@/components/grid/GridItems.vue";
export default {
  data() {
    return {
      pageTitle: null,
      pageSubTitle: null,
      hero: null,
      ro: null,
      elementSizes: [],
      resizeTrig: -1,
      category: null,
      productAttributesHash: [],
      items: [],
      paginate: ["filteredItems"],
      trigger: -1,
      filteredItems: [],
      filterTimer: 2000,
      hickup: 0,
      triggerQueryChange: -1,
      currentCategoryValue: null,
      categoryChanged: false,
      savedFilterChanged: false,
      activeFilters: [],
      currentItem: null,
      // pageReady: false,
      filtersReady: false,
      gridReady: false,
      cid: null,
      openMobileCats: false,
      mobileFiltersOpen: false,
      searchString: null
    };
  },
  components: {
    FilterPanel,
    GridItems
  },
  async beforeRouteUpdate(to, from, next) {
    this.triggerQueryChange = new Date().getTime();
    next();
  },
  watch: {
    $route() {
      this.toggleOverlay(false);
      this.initSearchTermParam();
    },
    "$route.query"() {
      if (this.$refs.paginator) {
        this.$nextTick(function() {
          if (this.hasPages) {
            this.$refs.paginator.goToPage(1);
          }
        });
      }
    },
    async "locale.ln"() {
      this.setPageReady(false);
      await this.fetchData(this.$route);
      this.setPageReady(true);
    }
  },
  async created() {
    await this.fetchData(this.$route);
    this.setPageReady(true);
  },
  async mounted() {
    this.initSearchTermParam();
  },
  destroyed() {
    this.updateFiltersHash([]);
  },
  computed: {
    ...mapState([
      "rawitems",
      "filtersHash",
      "pageReady",
      "locale",
      "dimensions"
    ]),
    hasPages() {
      return (
        this.filteredItems.length &&
        this.filteredItems.length > this.itemsPerPage
      );
    },
    itemsPerPage() {
      return 8;
    }
  },
  methods: {
    initSearchTermParam() {
      if (this.$route.params.searchterm) 
      {
        this.$set(
          this,
          "searchString",
          this.$route.params.searchterm.replace(/-/g, " ")
        );
      }
    },
    fetchItemPropsString(item) {
      let pick = _.pick(item, [
        "cat",
        "title",
        "description",
        "material",
        "platform",
        "connection"
      ]);
      return _.values(pick)
        .join("")
        .toLowerCase();
    },
    searchByString(string) {
      if (!string) {
        this.searchString = null;
        this.checkFilters();
      } else {
        this.searchString = string.toLowerCase();
        this.gridReady = false;
        this.$set(this, "filteredItems", []);
        this.$nextTick(async function() {
          this.$set(this, "filteredItems", await this.freeSearchItems());
          this.gridReady = true;
        });
      }
    },
    async freeSearchItems() {
      let items = _.sortBy(this.items, item => -new Date(item.date_created));
      if (this.searchString) {
        return items.filter(item => {
          let itemPropsString = this.fetchItemPropsString(item);
          return itemPropsString.indexOf(this.searchString) > -1;
        });
      }
      return items;
    },
    mobileFiltersChanged(bool) {
      this.mobileFiltersOpen = bool;
    },
    onLangsPageChange() {
      let top = this.$refs.grid.offsetTop - 60;
      window.scrollTo({ top, behavior: "smooth" });
    },
    async fetchData() {
      this.scrollToTop();
      let items = this.rawitems;
      if (!items) {
        items = await this.initRawItems();
      }
      let item = items.find(
        item => item.path.toLowerCase().indexOf("research-library") > -1
      );
      if (item && item.cid) {
        // console.log("item.cid >> ", item.cid);
        let layout = await this.initRouteByCid(item.cid);
        if (layout.children) {
          let hero = _.find(layout.children, { type: "slider" });
          this.$set(this, "hero", hero);

          let itemData = _.find(layout.children, { type: "common-data" });
          if (itemData && itemData.properties.title) {
            this.$set(this, "pageTitle", itemData.properties.title);
          }
          if (itemData && itemData.properties.subtitle) {
            this.$set(this, "pageSubTitle", itemData.properties.subtitle);
          }
          this.$set(this, "items", itemData.children);
        }

        await this.initFilters();
        this.filtersReady = true;
        this.checkFilters();
      } else {
        this.category = 404;
      }
      this.$nextTick(function() {
        this.initResizeObserver();
      });
      return true;
    },
    async initFilters() {
      let ln,
        cc,
        vm = this;

      // active cache?
      let useCache = vm.$useCache["research"];
      // locale keys
      ({ ln, cc } = this.locale);

      let storageKey = `filters_research_${ln}_${cc}`;

      return new Promise(async resolve => {
        let filters = storage.get(storageKey),
          _parsed;
        if (filters) {
          _parsed = JSON.parse(filters);
        } else {
          await fetch(
            `https://api.mis-implants.com/api/ui?type=articles_filters`,
            {
              headers: {
                ln,
                cc,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
              }
            }
          )
            .then(function(response) {
              return response.json();
            })
            .then(function(json) {
              // console.log("_json >> ", json);
              let filters = json.ui;
              // let _json = JSON.parse(json);
              filters.forEach(filter => {
                filter.visible = filter.type === "sCIDS";
              });
              // console.log("filters response > ", filters);
              useCache && storage.set(storageKey, filters);
              _parsed = filters;
              vm.$nextTick(function() {
                resolve(filters);
              });
            });
        }
        /*
            Check route query for active fitlers
            and update the filter hash accordingly
        */
        _parsed = vm.activateFiltersByQuery(_parsed);
        // console.log("_parsed after query .> ", _parsed);
        vm.updateFiltersHash(_parsed);
        vm.$nextTick(function() {
          resolve(_parsed);
        });
      });
    },
    /*
			Use URL query to filter items
			QUERY > TO > FILTER
		*/
    activateFiltersByQuery(_filters) {
      let query = this.$route.query,
        filters = _filters;
      if (query) {
        _.each(query, (v, k) => {
          let values = v.split(",");
          let parent = _.find(filters, { name: k });
          if (parent) {
            if (parent.value) {
              parent.value = values;
              parent.active = true;
            } else {
              _.each(values, value => {
                let item = _.find(
                  parent.filters,
                  f => f.name.toLowerCase() === value.toLowerCase()
                );
                if (item) {
                  item.active = true;
                }
              });
            }
            parent.visible = true;
          }
        });
      }
      return filters;
    },
    filtersChangedHandler(activefilters) {
      // console.log("filtersChangedHandler >> ", activefilters);
      this.activeFilters = activefilters;
      if (this.items.length) {
        this.checkFilters();
      }
    },
    async checkFilters() {
      // console.log("FCHEK FILTERS");
      this.gridReady = false;
      this.$set(this, "filteredItems", []);
      this.$nextTick(async function() {
        let items = await this.filterItems();
        // this.$set(this, "filteredItems", _.orderBy(items, "order", ["asc"]));
        this.$set(
          this,
          "filteredItems",
          _.orderBy(items, "order", ["asc"])

          // _.sortBy(items, item => -new Date(item.date_created))
        );
        this.gridReady = true;
        // console.log("GRID READY");
      });
    },
    async filterItems() {
      // console.log("FILTER ITESM >> ", this.items);
      if (!this.activeFilters.length) {
        return this.items;
      }
      let group = _.groupBy(this.activeFilters, "type"), // keyed filters
        items = this.items;

      // console.log("group >> ", group);

      for (var type in group) {
        // let type =
        let _ids = _.map(group[type], "id");
        if (type === "sCIDS") {
          // console.log("sCIDS > ", _.map(_ids, Number));
          items = _.filter(
            items,
            item => _.map(_ids, Number).indexOf(item.pid) > -1
          );
        } else if (type === "sCPIDS") {
          // products
          items = _.filter(items, item =>
            item.products.some(v => _.map(_ids, Number).indexOf(v) >= 0)
          );
        } else if (type === "sYR") {
          // year
          items = _.filter(
            items,
            item => _ids.indexOf(item.date_created.split("/")[2]) > -1
          );
        } else if (type === "sSt") {
          // study
          items = _.filter(items, item => _ids.indexOf(item.studyType) > -1);
        }
      }

      return items;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    /*
      Will set off everytime an element has
      resized and will change a random trigger
      that Components can listen to if needed.
    */
    triggerResize: _.debounce(function() {
      this.resizeTrig = new Date().getTime();
    }, 300),
    removeResizeObserver() {
      const vm = this,
        els = document.querySelectorAll(".page-component");
      this.elementSizes.length = els.length;
      [...els].forEach(el => vm.ro.unobserve(el));
    },
    initResizeObserver: _.debounce(async function() {
      const vm = this;
      /*
        The callback will fire for every
        observed element resize

      */
      if ("ResizeObserver" in window === false) {
        // Loads polyfill asynchronously, only if required.
        const module = await import("@juggle/resize-observer");
        window.ResizeObserver = module.ResizeObserver;
      }
      this.ro = new ResizeObserver(entries => {
        // console.log("Elements resized:", entries.length);
        entries.forEach(
          _.debounce((entry, index) => {
            vm.adjustResponsiveClasses(entry, index);
            vm.triggerResize();
          }, 300)
        );
      });
      /*
        Catch all root level components
        and start observing them for resizes...
      */
      const els = document.querySelectorAll(".page-component");
      this.elementSizes.length = els.length;
      [...els].forEach((el, index) => {
        vm.ro.observe(el, { box: "border-box" });
        vm.adjustResponsiveClasses(el, index);
      });
    }, 300),
    adjustResponsiveClasses(entry, index) {
      let width;
      if (entry.contentRect) {
        const { left, right } = entry.contentRect;
        width = left + right;
      } else {
        width = entry.offsetWidth;
      }
      if (width > 1200) {
        this.$set(this.elementSizes, index, "large");
      } else if (width > 767) {
        this.$set(this.elementSizes, index, "medium");
      } else {
        this.$set(this.elementSizes, index, "small");
      }
    },
    toggleMobileCats() {
      this.openMobileCats = !this.openMobileCats;
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = this.limited ? "translateX(20%)" : "translateY(20%)";
    },
    enter: function(el, done) {
      var vm = this,
        lapse = this.limited ? 280 : 120,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: vm.limited
              ? ["translateX(20%)", "translateX(0)"]
              : ["translateY(20%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = this.limited
        ? "translateX(120%)"
        : "translateY(120%)";
      done();
    },
    ...mapActions([
      "initRawItems",
      "initRouteByCid",
      "updateFiltersHash",
      "setPageReady",
      "toggleOverlay"
    ])
  }
};
</script>
<style lang="stylus">
.toggle
  position relative
  z-index 99
.page
  position relative
  // background linear-gradient(to bottom, gray_0 80%, #fff)
  z-index 9
.research
  background #fff
  // min-height 70vh
  .filter-panel__mobile
    top 0
  // &.filters-open
  //   max-height 100vh
  //   overflow hiddens
  .publication-list
    width 80%
  &--inner
    width 100%
    position relative
    _flex(row, nowrap, flex-start, space-between)
    text-align left

  &--grid
    position relative
    +below(769px)
      padding 4vh 0 0 0 !important
</style>
